module.exports = __webpack_public_path__ + "static/media/TC01@m.761b640f.jpg";